export const Mark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="14" fill="#0B192C" stroke="rgba(212,175,55,.35)" />
    <path d="M17 17 32 8l15 9" fill="none" stroke="#D4AF37" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10 22h6l9 24 6-15" fill="none" stroke="#E6C280" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M36 22v24M38 35l13-13M42 31l11 15" fill="none" stroke="#D4AF37" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 52c14 4 34 2 48-10" fill="none" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const Overline = ({ children, className = "" }) => (
  <p className={`font-mono-d text-xs uppercase tracking-[0.28em] text-[#D4AF37] ${className}`}>{children}</p>
);
